<!--
  CRN_20251216 - Autofill, browser history is a real pain!
               - Used name=[something]-secret to get around it
               - Example - mdmForm_mdmMicrosoftTenantId-field-secret
-->

<ng-template #companyModalForm role="document" let-modal>

  <app-modal-comp-header
    [fileLockHoverText]="fileLockHoverText"
    modalForm="Company"
    [showFileLockIcon]="formIsLocked"
    [showMessageIcon]="!newCompany && showMessageIcon"
    [title]="formTitle"
    (cancelButtonOnClick)="companyFormCancel()"
    (messageButtonOnClick)="messageClick()"
  ></app-modal-comp-header>
  
  <form
    autocomplete="off"
    [attr.autocomplete]="autofill ? 'on' : 'off'"
    class="tablelist-form"
    [formGroup]="companyForm"
    (ngSubmit)="companyFormSubmit()"
  >
    <div class="modal-body">
      <ul ngbNav #ArrowNgbNav="ngbNav" [(activeId)]="activeId" (navChange)="onTabChange($event)" class="nav nav-pills arrow-navtabs nav-success bg-light mb-3">
  
        <li [ngbNavItem]="navItemBasicDetails">
          <a ngbNavLink>
            @if(showCompanyTabIcons) {
              <span class="d-block"><i class="mdi mdi-city"></i></span>
            }
            <span class="d-sm-block">{{tabTitleBasic}}</span>
          </a>
          <ng-template ngbNavContent>
            <div formGroupName="basicDetailsForm">
              @if(newCompany){
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                      <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                      <span [innerHtml]="progressInformation"></span>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="inviewCompanyId-field" class="form-label text-right"
                      [class.required]="isRequired('basicDetailsForm.inviewCompanyId')"
                    >
                      Company
                    </label>
                    <select
                      class="form-select"
                      name="inviewCompanyId-field"
                      id="inviewCompanyId-field"
                      formControlName="inviewCompanyId"
                      (change)="inviewCompanySelectDropDownChange($event)"
                      [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['inviewCompanyId'].errors }"
                    >
                      <option selected></option>
                      @for (object of getDropdownDataObjectArrayForInviewCompany("inviewCompanyId"); track object.companyId) {
                        <option [ngValue]="object.companyId">{{object.companyName}}</option>    
                      }
                    </select>
                    <div class="invalid-feedback">A value is required</div>
                  </div>
                </div>
              </div>
              }
  
              @if(newCompany && (createNewCompanySelected || inviewCompanySelected)){
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="inviewParentCompanyId-field" class="form-label text-right"
                      [class.required]="isRequired('basicDetailsForm.inviewParentCompanyId')"
                    >
                      Parent Company
                    </label>
                    <select
                      class="form-select"
                      name="inviewParentCompanyId-field"
                      id="inviewParentCompanyId-field"
                      formControlName="inviewParentCompanyId"
                      (change)="inviewParentCompanySelectDropDownChange($event)"
                      [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['inviewParentCompanyId'].errors }"
                    >
                      <option selected></option>
                      @for (object of getDropdownDataObjectArray("inviewParentCompanyId"); track object.id) {
                        <option [ngValue]="object.id">{{object.description}}</option>    
                      }
                    </select>
                    <div class="invalid-feedback">A value is required</div>
                  </div>
                </div>
              </div>
              }
  
              @if(inviewParentCompanySelected || !newCompany) {
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="companyname-field" class="form-label"
                      [class.required]="isRequired('basicDetailsForm.companyname')"
                    >
                      Company Name
                    </label>
                    <input
                      [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                      [attr.name]="autofill ? 'companyname-field' : 'companyname-field-secret'"
                      class="form-control"
                      data-lpignore="true"
                      formControlName="companyname"
                      id="companyname-field"
                      [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['companyname'].errors }"
                      placeholder=""
                      type="text"
                    />
                    @if(formOfBasicDetails['companyname'].hasError('maxlength')) {
                      <div class="invalid-feedback">Maximum length of {{companynameMaxLength}} characters has been exceeded</div>
                    } @else {
                      <div class="invalid-feedback">A value is required</div>
                    }
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-6">
                  <div class="mb-3">
                    <label for="companyTypeId-field" class="form-label text-right"
                      [class.required]="isRequired('basicDetailsForm.companyTypeId')"
                    >
                      Company Type
                    </label>
                    <select
                      class="form-select"
                      name="companyTypeId-field"
                      id="companyTypeId-field"
                      formControlName="companyTypeId"
                      [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['companyTypeId'].errors }"
                      (change)="companyTypeDropDownChange($event)"
                    >
                      <option selected></option>
                      @for (object of getDropdownDataObjectArray("companyTypeId"); track object.id) {
                        <option [ngValue]="object.id">{{object.description}}</option>    
                      }
                    </select>
                    <div class="invalid-feedback">A value is required</div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="mb-3">
                    <label for="countryId-field" class="form-label text-right"
                      [class.required]="isRequired('basicDetailsForm.countryId')"
                    >
                      Country
                    </label>
                    <select
                      class="form-select"
                      name="countryId-field"
                      id="countryId-field"
                      formControlName="countryId"
                      (change)="countryIdDropDownChange($event)"
                      [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['countryId'].errors }"
                    >
                      <option selected></option>
                      @for (object of getDropdownDataObjectArray("countryId"); track object.id) {
                        <option [ngValue]="object.id">{{object.description}}</option>    
                      }
                    </select>
                    <div class="invalid-feedback">A value is required</div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-6">

                  <div class="row">
                    <div class="mb-3">
                      <div class="border border-success rounded" [ngClass]="{ 'is-invalid': companyFormSubmitted && mandatoryAddress && (companyAddressId == null || companyAddressId == undefined || companyAddressId<=0) }">
  
                        <div class="row">
                          <div class="col-12">
                            <div>
                              <div class="alert border-0 alert-primary" role="alert">
                                <strong>Company Address</strong>
                                <span class="position-absolute top-50 end-0 translate-middle-y px-2">
                                  <button [disabled]="formIsLocked" class="btn btn-success" type="button" (click)="editAddress(true)">
                                    Edit
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        @if ((formOfBasicDetails["billingAddrLine1"].value != undefined && formOfBasicDetails["billingAddrLine1"].value != "") ||
                             (formOfBasicDetails["companyAddrLine1"].value != undefined && formOfBasicDetails["companyAddrLine1"].value != "")) {
                          <div class="row">
                            <div class="col-4">
                              <div class="mb-0 px-2">
                                @if (formOfBasicDetails["companyAddrLine1"].value != undefined && formOfBasicDetails["companyAddrLine1"].value != "") {
                                  <input
                                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                    [attr.name]="autofill ? 'companyAddrLine1-label' : 'companyAddrLine1-label-secret'"
                                    class="form-control border-0"
                                    data-lpignore="true"
                                    id="companyAddrLine1-label"
                                    readonly
                                    type="text"
                                    value="First Line"
                                  />
                                }
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="mb-0 px-2">
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'companyAddrLine1-field' : 'companyAddrLine1-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="companyAddrLine1"
                                  id="companyAddrLine1-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>
                        }
                         
                      @if ((formOfBasicDetails["billingAddrLine2"].value != undefined && formOfBasicDetails["billingAddrLine2"].value != "") || 
                           (formOfBasicDetails["companyAddrLine2"].value != undefined && formOfBasicDetails["companyAddrLine2"].value != "")) {
                          <div class="row">
                            <div class="col-4">
                              <div class="mb-0 px-2">
                                @if (formOfBasicDetails["companyAddrLine2"].value != undefined && formOfBasicDetails["companyAddrLine2"].value != "") {
                                 <input
                                   [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                   [attr.name]="autofill ? 'companyAddrLine2-label' : 'companyAddrLine2-label-secret'"
                                   class="form-control border-0"
                                   data-lpignore="true"
                                   id="companyAddrLine2-label"
                                   readonly
                                   type="text"
                                   value=""
                                 />
                                }
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="mb-0 px-2">
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'companyAddrLine2-field' : 'companyAddrLine2-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="companyAddrLine2"
                                  id="companyAddrLine2-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>
                        }
  
                      @if ((formOfBasicDetails["billingAddrLine3"].value != undefined && formOfBasicDetails["billingAddrLine3"].value != "") || 
                           (formOfBasicDetails["companyAddrLine3"].value != undefined && formOfBasicDetails["companyAddrLine3"].value != "")) {
                          <div class="row">
                            <div class="col-4">
                              <div class="mb-0 px-2">
                                @if (formOfBasicDetails["companyAddrLine3"].value != undefined && formOfBasicDetails["companyAddrLine3"].value != "") {
                                  <input
                                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                    [attr.name]="autofill ? 'companyAddrLine3-label' : 'companyAddrLine3-label-secret'"
                                    class="form-control border-0"
                                    data-lpignore="true"
                                    id="companyAddrLine3-label"
                                    readonly
                                    type="text"
                                    value=""
                                  />
                                }
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="mb-0 px-2">
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'companyAddrLine3-field' : 'companyAddrLine3-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="companyAddrLine3"
                                  id="companyAddrLine3-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>
                        }
  
                      @if ((formOfBasicDetails["billingAddrTownOrCity"].value != undefined && formOfBasicDetails["billingAddrTownOrCity"].value != "") ||
                           (formOfBasicDetails["companyAddrTownOrCity"].value != undefined && formOfBasicDetails["companyAddrTownOrCity"].value != "")) {
                          <div class="row">
                            <div class="col-4">
                              <div class="mb-0 px-2">
                                @if (formOfBasicDetails["companyAddrTownOrCity"].value != undefined && formOfBasicDetails["companyAddrTownOrCity"].value != "") {
                                  <input
                                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                    [attr.name]="autofill ? 'companyAddrTownOrCity-label' : 'companyAddrTownOrCity-label-secret'"
                                    class="form-control border-0"
                                    data-lpignore="true"
                                    id="companyAddrTownOrCity-label"
                                    readonly
                                    type="text"
                                    value="Town/City"
                                  />
                                }
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="mb-0 px-2">
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'companyAddrTownOrCity-field' : 'companyAddrTownOrCity-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="companyAddrTownOrCity"
                                  id="companyAddrTownOrCity-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>
                        }
  
                      @if ((formOfBasicDetails["billingAddrCounty"].value != undefined && formOfBasicDetails["billingAddrCounty"].value != "") ||
                           (formOfBasicDetails["companyAddrCounty"].value != undefined && formOfBasicDetails["companyAddrCounty"].value != "")) {
                        <div class="row">
                          <div class="col-4">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["companyAddrCounty"].value != undefined && formOfBasicDetails["companyAddrCounty"].value != "") {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'companyAddrCounty-label' : 'companyAddrCounty-label-secret'"
                                  class="form-control border-0"
                                  data-lpignore="true"
                                  id="companyAddrCounty-label"
                                  readonly
                                  type="text"
                                  value="County"
                                />
                              }
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-0 px-2">
                              <input
                                [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                [attr.name]="autofill ? 'companyAddrCounty-field' : 'companyAddrCounty-field-secret'"
                                class="form-control text-end border-0"
                                data-lpignore="true"
                                formControlName="companyAddrCounty"
                                id="companyAddrCounty-field"
                                placeholder=""
                                readonly
                                type="text"
                              />
                            </div>
                          </div>
                        </div>
                        }
  
                      @if ((formOfBasicDetails["billingAddrPostCode"].value != undefined && formOfBasicDetails["billingAddrPostCode"].value != "") ||
                           (formOfBasicDetails["companyAddrPostCode"].value != undefined && formOfBasicDetails["companyAddrPostCode"].value != "")) {
                        <div class="row">
                          <div class="col-4">
                            <div class="mb-2 px-2">
                              @if (formOfBasicDetails["companyAddrPostCode"].value != undefined && formOfBasicDetails["companyAddrPostCode"].value != "") {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'companyAddrPostCode-label' : 'companyAddrPostCode-label-secret'"
                                  class="form-control border-0"
                                  data-lpignore="true"
                                  id="companyAddrPostCode-label"
                                  readonly
                                  type="text"
                                  value="PostCode"
                                />
                              }
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-2 px-2">
                              <input
                                [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                [attr.name]="autofill ? 'companyAddrPostCode-field' : 'companyAddrPostCode-field-secret'"
                                class="form-control text-end border-0"
                                data-lpignore="true"
                                formControlName="companyAddrPostCode"
                                id="companyAddrPostCode-field"
                                placeholder=""
                                readonly
                                type="text"
                              />
                            </div>
                          </div>
                        </div>
                        }
  
                        <div class="row" hidden="true">
                          <div class="col-4">
                            <div class="mb-0 px-2">
                              <input
                                [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                [attr.name]="autofill ? 'companyAddrCountryId-label' : 'companyAddrCountryId-label-secret'"
                                class="form-control border-0"
                                data-lpignore="true"
                                id="companyAddrCountryId-label"
                                readonly
                                type="text"
                                value="Country"
                              />
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-0 px-2">
                             <select #companyAddrCountryId
                               class="form-select  border-0"
                               formControlName="companyAddrCountryId"
                               id="companyAddrCountryId-field"
                               name="companyAddrCountryId-field"
                             >
                               <option selected></option>
                               @for (object of getDropdownDataObjectArray("countryId"); track object.id) {
                                 <option [ngValue]="object.id">{{object.description}}</option>    
                               }
                             </select>
                            </div>
                          </div>
                        </div>
  
                        @if ((companyAddrCountryId.options.selectedIndex != undefined &&
                              companyAddrCountryId.options[companyAddrCountryId.options.selectedIndex].text.trim() != "") ||
                             (billingAddrCountryId.options.selectedIndex != undefined && billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex] != undefined && billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex].text.trim() != "")) {
                          <div class="row">
                            <div class="col-4">
                              <div class="mb-0 px-2">
                                @if (companyAddrCountryId.options.selectedIndex != undefined && companyAddrCountryId.options[companyAddrCountryId.options.selectedIndex] != undefined && companyAddrCountryId.options[companyAddrCountryId.options.selectedIndex].text.trim() != "") {
                                  <input
                                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                    [attr.name]="autofill ? 'companyAddrCountryIdInput-label' : 'companyAddrCountryIdInput-label-secret'"
                                    readonly
                                    type="text"
                                    id="companyAddrCountryIdInput-label"
                                    class="form-control border-0"
                                    data-lpignore="true"
                                    value="Country"
                                  />
                                }
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="mb-0 px-2">
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'companyAddrCountryIdInput-field' : 'companyAddrCountryIdInput-field-secret'"
                                  class="form-control text-end border-0"
                                  id="companyAddrCountryIdInput-field"
                                  placeholder=""
                                  type="text"
                                  readonly
                                  [value]="companyAddrCountryId.options[companyAddrCountryId.options.selectedIndex].text"
                                />
                              </div>
                            </div>
                          </div>
                        }
      
                      </div>
                      <div class="invalid-feedback">An address is required</div>
                    </div>

                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="domain-field" class="form-label"
                              [class.required]="isRequired('basicDetailsForm.domain')"
                            >
                              Domain
                            </label>
                            <input
                              [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                              [attr.name]="autofill ? 'domain-field' : 'domain-field-secret'"
                              class="form-control"
                              data-lpignore="true"
                              formControlName="domain"
                              id="domain-field"
                              [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['domain'].errors }"
                              placeholder="exampleDomain.com"
                              type="text"
                            />

                            @if(formOfBasicDetails['domain'].hasError('maxlength')) {
                              <div class="invalid-feedback">Maximum length of {{domainMaxLength}} characters has been exceeded</div>
                            } @else {
                              <div class="invalid-feedback">A value is required</div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-6">
                  <div class="mb-3">
                    <div class="border border-success rounded" [ngClass]="{ 'is-invalid': companyFormSubmitted && mandatoryAddress && (billingAddressId == null || billingAddressId == undefined || billingAddressId<=0) }">

                      <div class="row">
                        <div class="col-12">
                          <div>
                            <div class="alert border-0 alert-primary" role="alert">
                              <strong>Billing Address</strong>

                              @if (!billingAddressAsCompany) {
                                <span class="position-absolute top-50 end-0 translate-middle-y px-2">
                                  <button [disabled]="formIsLocked" class="btn btn-success" type="button" (click)="editAddress(false)">Edit</button>
                                </span>
                              }

                            </div>
                          </div>
                        </div>
                      </div>
                      
                      @if ((formOfBasicDetails["billingAddrLine1"].value != undefined && formOfBasicDetails["billingAddrLine1"].value != "") ||
                           (formOfBasicDetails["companyAddrLine1"].value != undefined && formOfBasicDetails["companyAddrLine1"].value != "")) {
                        <div class="row">
                          <div class="col-4">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrLine1"].value != undefined && formOfBasicDetails["billingAddrLine1"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrLine1-label' : 'billingAddrLine1-label-secret'"
                                  class="form-control border-0"
                                  data-lpignore="true"
                                  id="billingAddrLine1-label"
                                  readonly
                                  type="text"
                                  value="First Line"
                                />
                              }
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrLine1"].value != undefined && formOfBasicDetails["billingAddrLine1"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrLine1-field' : 'billingAddrLine1-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="billingAddrLine1"
                                  id="billingAddrLine1-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              } @else {
                                <div class="mb-3 px-2">
                                   &nbsp;
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                       
                      @if ((formOfBasicDetails["billingAddrLine2"].value != undefined && formOfBasicDetails["billingAddrLine2"].value != "") ||
                           (formOfBasicDetails["companyAddrLine2"].value != undefined && formOfBasicDetails["companyAddrLine2"].value != "")) {
                        <div class="row">
                          <div class="col-4">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrLine2"].value != undefined && formOfBasicDetails["billingAddrLine2"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrLine2-label' : 'billingAddrLine2-label-secret'"
                                  readonly
                                  type="text"
                                  id="billingAddrLine2-label"
                                  class="form-control border-0"
                                  data-lpignore="true"
                                  value=""
                                />
                              }
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrLine2"].value != undefined && formOfBasicDetails["billingAddrLine2"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrLine2-field' : 'billingAddrLine2-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="billingAddrLine2"
                                  id="billingAddrLine2-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              } @else {
                                <div class="mb-3 px-2">
                                   &nbsp;
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      @if ((formOfBasicDetails["billingAddrLine3"].value != undefined && formOfBasicDetails["billingAddrLine3"].value != "") || 
                           (formOfBasicDetails["companyAddrLine3"].value != undefined && formOfBasicDetails["companyAddrLine3"].value != "")) {
                        <div class="row">
                          <div class="col-4">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrLine3"].value != undefined && formOfBasicDetails["billingAddrLine3"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrLine3-label' : 'billingAddrLine3-label-secret'"
                                  class="form-control border-0"
                                  data-lpignore="true"
                                  id="billingAddrLine3-label"
                                  readonly
                                  type="text"
                                  value=""
                                />
                              }
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrLine3"].value != undefined && formOfBasicDetails["billingAddrLine3"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrLine3-field' : 'billingAddrLine3-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="billingAddrLine3"
                                  id="billingAddrLine3-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              } @else {
                                <div class="mb-3 px-2">
                                   &nbsp;
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      @if ((formOfBasicDetails["billingAddrTownOrCity"].value != undefined && formOfBasicDetails["billingAddrTownOrCity"].value != "") ||
                           (formOfBasicDetails["companyAddrTownOrCity"].value != undefined && formOfBasicDetails["companyAddrTownOrCity"].value != "")) {
                        <div class="row">
                          <div class="col-4">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrTownOrCity"].value != undefined && formOfBasicDetails["billingAddrTownOrCity"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrTownOrCity-label' : 'billingAddrTownOrCity-label-secret'"
                                  class="form-control border-0"
                                  data-lpignore="true"
                                  id="billingAddrTownOrCity-label"
                                  readonly
                                  type="text"
                                  value="Town/City"
                                />
                              }
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-0 px-2">
                              @if (formOfBasicDetails["billingAddrTownOrCity"].value != undefined && formOfBasicDetails["billingAddrTownOrCity"].value != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrTownOrCity-field' : 'billingAddrTownOrCity-field-secret'"
                                  class="form-control text-end border-0"
                                  data-lpignore="true"
                                  formControlName="billingAddrTownOrCity"
                                  id="billingAddrTownOrCity-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                />
                              } @else {
                                <div class="mb-3 px-2">
                                   &nbsp;
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      @if ((formOfBasicDetails["billingAddrCounty"].value != undefined && formOfBasicDetails["billingAddrCounty"].value != "") ||
                           (formOfBasicDetails["companyAddrCounty"].value != undefined && formOfBasicDetails["companyAddrCounty"].value != "")) {
                      <div class="row">
                        <div class="col-4">
                          <div class="mb-0 px-2">
                            @if (formOfBasicDetails["billingAddrCounty"].value != undefined && formOfBasicDetails["billingAddrCounty"].value != "" && !billingAddressAsCompany) {
                              <input
                                [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                [attr.name]="autofill ? 'billingAddrCounty-label' : 'billingAddrCounty-label-secret'"
                                class="form-control border-0"
                                data-lpignore="true"
                                id="billingAddrCounty-label"
                                readonly
                                type="text"
                                value="County"
                              />
                            }
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="mb-0 px-2">
                            @if (formOfBasicDetails["billingAddrCounty"].value != undefined && formOfBasicDetails["billingAddrCounty"].value != "" && !billingAddressAsCompany) {
                              <input
                                [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                [attr.name]="autofill ? 'billingAddrCounty-field' : 'billingAddrCounty-field-secret'"
                                class="form-control text-end border-0"
                                data-lpignore="true"
                                formControlName="billingAddrCounty"
                                id="billingAddrCounty-field"
                                placeholder=""
                                readonly
                                type="text"
                              />
                            } @else {
                                <div class="mb-3 px-2">
                                   &nbsp;
                                </div>
                            }
                          </div>
                        </div>
                      </div>
                      }

                      @if ((formOfBasicDetails["billingAddrPostCode"].value != undefined && formOfBasicDetails["billingAddrPostCode"].value != "") ||
                           (formOfBasicDetails["companyAddrPostCode"].value != undefined && formOfBasicDetails["companyAddrPostCode"].value != "")) {
                      <div class="row">
                        <div class="col-4">
                          <div class="mb-2 px-2">
                            @if (formOfBasicDetails["billingAddrPostCode"].value != undefined && formOfBasicDetails["billingAddrPostCode"].value != "" && !billingAddressAsCompany) {
                              <input
                                [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                [attr.name]="autofill ? 'billingAddrPostCode-label' : 'billingAddrPostCode-label-secret'"
                                class="form-control border-0"
                                data-lpignore="true"
                                id="billingAddrPostCode-label"
                                readonly
                                type="text"
                                value="PostCode"
                              />
                            }
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="mb-2 px-2">
                            @if (formOfBasicDetails["billingAddrPostCode"].value != undefined && formOfBasicDetails["billingAddrPostCode"].value != "" && !billingAddressAsCompany) {
                              <input
                                [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                [attr.name]="autofill ? 'billingAddrPostCode-field' : 'billingAddrPostCode-field-secret'"
                                class="form-control text-end border-0"
                                data-lpignore="true"
                                formControlName="billingAddrPostCode"
                                id="billingAddrPostCode-field"
                                placeholder=""
                                readonly
                                type="text"
                              />
                            } @else {
                                <div class="mb-3 px-2">
                                   &nbsp;
                                </div>
                            }
                          </div>
                        </div>
                      </div>
                      }

                      <div class="row" hidden="true">
                        <div class="col-4">
                          <div class="mb-0 px-2">
                            <input
                              [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                              [attr.name]="autofill ? 'billingAddrCountryId-label' : 'billingAddrCountryId-label-secret'"
                              class="form-control border-0"
                              data-lpignore="true"
                              id="billingAddrCountryId-label"
                              readonly
                              type="text"
                              value="Country"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="mb-0 px-2">
                           <select #billingAddrCountryId
                             class="form-select  border-0"
                             formControlName="billingAddrCountryId"
                             id="billingAddrCountryId-field"
                             name="billingAddrCountryId-field"
                           >
                             <option selected></option>
                             @for (object of getDropdownDataObjectArray("countryId"); track object.id) {
                               <option [ngValue]="object.id">{{object.description}}</option>    
                             }
                           </select>
                          </div>
                        </div>
                      </div>

                      @if ((billingAddrCountryId.options.selectedIndex != undefined && billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex] != undefined && billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex].text.trim() != "") ||
                           (companyAddrCountryId.options.selectedIndex != undefined && companyAddrCountryId.options[companyAddrCountryId.options.selectedIndex].text.trim() != "")) {
                        <div class="row">
                          <div class="col-4">
                            <div class="mb-0 px-2">
                              @if (billingAddrCountryId.options.selectedIndex != undefined && billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex] != undefined && billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex].text.trim() != "" && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrCountryIdInput-label' : 'billingAddrCountryIdInput-label-secret'"
                                  class="form-control border-0"
                                  data-lpignore="true"
                                  id="billingAddrCountryIdInput-label"
                                  readonly
                                  type="text"
                                  value="Country"
                                />
                              }
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="mb-0 px-2">
                              @if (billingAddrCountryId.options.selectedIndex != undefined && billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex] != undefined && !billingAddressAsCompany) {
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'billingAddrCountryIdInput-field' : 'billingAddrCountryIdInput-field-secret'"
                                  class="form-control text-end border-0"
                                  id="billingAddrCountryIdInput-field"
                                  placeholder=""
                                  readonly
                                  type="text"
                                  [value]="billingAddrCountryId.options[billingAddrCountryId.options.selectedIndex].text"
                                />
                              } @else {
                                <div class="mb-3 px-2">
                                   &nbsp;
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      <div class="row">
                        <div class="col-12">
                          <div class="mb-4">
                            <label class="form-label"></label>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row">
                        <div class="col-12 position-absolute bottom-0" style="margin-left: -1px;">
                          <div class="alert border border-success rounded alert-light" role="alert">
                            <label class="form-label text-right"></label>
                            <span class="position-absolute top-50 start-0 translate-middle-y px-2">
                              <div class="form-check form-switch form-switch-md">
                                <label class="as-company-address-label text-muted" for="as-company-address-check">as Company</label>
                                <input
                                  class="form-check-input"
                                  formControlName="asCompanyAddress"
                                  id="as-company-address-check"
                                  role="switch"
                                  type="checkbox"
                                  (click)="asCompanyAddressClick()"
                                />
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="invalid-feedback position-absolute bottom-0">An address is required</div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-6">
                  <div class="mb-3">
                    <label for="regno-field" class="form-label"
                      [class.required]="isRequired('basicDetailsForm.regno')"
                    >
                      Company Registration Number
                    </label>
                    <input
                      [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                      [attr.name]="autofill ? 'regno-field' : 'regno-field-secret'"
                      class="form-control"
                      data-lpignore="true"
                      formControlName="regno"
                      id="regno-field"
                      [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['regno'].errors }"
                      placeholder=""
                      type="text"
                    />
                    @if(formOfBasicDetails['regno'].hasError('maxlength')) {
                      <div class="invalid-feedback">Maximum length of {{regnoMaxLength}} characters has been exceeded</div>
                    } @else {
                      <div class="invalid-feedback">A value is required</div>
                    }
                  </div>
                </div>  
                <div class="col-6">
                  <div class="mb-3">
                    <label for="vatno-field" class="form-label"
                      [class.required]="isRequired('basicDetailsForm.vatno')"
                    >
                      VAT Number
                    </label>
                    <input
                      [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                      [attr.name]="autofill ? 'vatno-field' : 'vatno-field-secret'"
                      class="form-control"
                      data-lpignore="true"
                      formControlName="vatno"
                      id="vatno-field"
                      [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['vatno'].errors }"
                      placeholder=""
                      type="text"
                    />
                    @if(formOfBasicDetails['vatno'].hasError('maxlength')) {
                      <div class="invalid-feedback">Maximum length of {{vatnoMaxLength}} characters has been exceeded</div>
                    } @else {
                      <div class="invalid-feedback">A value is required</div>
                    }
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-auto">
                  <div class="form-check form-switch form-switch-md">
                    <label class="form-check-label" for="active-field">Active</label>
                    <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active" (click)="activeClick()">
                  </div>
                </div>
                @if(showDropdownShowAtTop) {
                  <div class="col-auto">
                    <div class="form-check form-switch form-switch-md">
                      <label class="form-check-label" for="dropdownShowAtTop-field">Show at Top of Company Dropdown</label>
                      <input class="form-check-input" type="checkbox" role="switch" id="dropdownShowAtTop-field" formControlName="dropdownShowAtTop">
                    </div>
                  </div>
                }
              </div>

              @if(showSupportPlan) {
                <div class="row mt-2">
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="supportPlanId-field" class="form-label text-right">Support Plan</label>
                      <select
                        class="form-select"
                        name="supportPlanId-field"
                        id="supportPlanId-field"
                        formControlName="supportPlanId"
                        (change)="supportPlanDropDownChange($event)"
                      >
                        <option [ngValue]="''"></option>
                        @for (object of getDropdownDataObjectArray("supportPlanId"); track object.id) {
                          <option [ngValue]="object.id">{{object.description}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  @if(showAccountManager) {
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="accountManagerId-field" class="form-label text-right">Account Manager</label>
                        <select
                          class="form-select"
                          name="accountManagerId-field"
                          id="accountManagerId-field"
                          formControlName="accountManagerId"
                        >
                          <option [ngValue]="''"></option>
                          @for (object of getDropdownDataObjectArray("accountManagerId"); track object.id) {
                            <option [ngValue]="object.id">{{object.description}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                </div>
              }

              @if(showInventoryOrgId) {
                <div class="row mt-2">
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="inventoryOrgId-field" class="form-label">Inventory Account</label>
                      <input
                        class="form-control"
                        data-lpignore="true"
                        formControlName="inventoryOrgId"
                        id="inventoryOrgId-field"
                        min="1"
                        [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfBasicDetails['inventoryOrgId'].errors }"
                        placeholder="Not linked"
                        step="1"
                        type="number"
                      />
                      <div class="invalid-feedback">Enter a whole number greater than zero, or leave blank to unlink</div>
                      <div class="form-text">Lucy Org ID</div>
                    </div>
                  </div>
                </div>
              }

              @if(!newCompany && (testAccountChkBxKeepVisible || formOfBasicDetails['testAccount'].value)) {
                <div class="row">
                  <div class="col-12">
                    <div class="form-check form-switch form-switch-md">
                      <label class="form-check-label" for="testAccount-field">Test Account</label>
                      <input class="form-check-input" type="checkbox" role="switch" id="testAccount-field" formControlName="testAccount" (click)="testAccountClick()">
                    </div>
                  </div>
                </div>
              }

              }
            </div>
          </ng-template>
        </li>
        
        @if (showInvoiceDetails) {
          <li [ngbNavItem]="navItemInvoiceDetails">
            <a ngbNavLink>
              @if(showCompanyTabIcons) {
                <span class="d-block"><i class="mdi mdi-sigma"></i></span>
              }
              <span class="d-sm-block">{{tabTitleInvoice}}</span>
            </a>
            <ng-template ngbNavContent>
              <div formGroupName="invoiceDetailsForm">
                
                <div class="row">
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="invoiceDetails_AccountRef-field" class="form-label"
                        [class.required]="isRequired('invoiceDetailsForm.invoiceDetails_AccountRef')"
                      >
                        Account Reference
                      </label>
                      <input
                        [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                        [attr.name]="autofill ? 'invoiceDetails_AccountRef-field' : 'invoiceDetails_AccountRef-field-secret'"
                        class="form-control"
                        data-lpignore="true"
                        formControlName="invoiceDetails_AccountRef"
                        id="invoiceDetails_AccountRef-field"
                        [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_AccountRef'].errors }"
                        placeholder=""
                        type="text"
                      />
                      @if(formOfInvoiceDetails['invoiceDetails_AccountRef'].hasError('maxlength')) {
                        <div class="invalid-feedback">Maximum length of {{accountRefMaxLength}} characters has been exceeded</div>
                      } @else {
                        <div class="invalid-feedback">A value is required</div>
                      }
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="invoiceDetails_CurrencyId-field" class="form-label text-right"
                        [class.required]="isRequired('invoiceDetailsForm.invoiceDetails_CurrencyId')"
                      >
                        Currency
                      </label>
                      <select
                        class="form-select"
                        name="invoiceDetails_CurrencyId-field"
                        id="invoiceDetails_CurrencyId-field"
                        formControlName="invoiceDetails_CurrencyId"
                        [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_CurrencyId'].errors }"
                      >
                        <option selected></option>
                        @for (object of getDropdownDataObjectArray("invoiceDetails_CurrencyId"); track object.id) {
                          <option [ngValue]="object.id">{{object.description}}</option>    
                        }
                      </select>
                      <div class="invalid-feedback">A value is required</div>
                    </div>
                  </div>
                </div>
              
                <div class="row">
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="invoiceDetails_PaymentMethodId-field" class="form-label text-right"
                        [class.required]="isRequired('invoiceDetailsForm.invoiceDetails_PaymentMethodId')"
                      >
                        Payment Method
                      </label>
                      <select
                        class="form-select"
                        name="invoiceDetails_PaymentMethodId-field"
                        id="invoiceDetails_PaymentMethodId-field"
                        formControlName="invoiceDetails_PaymentMethodId"
                        [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_PaymentMethodId'].errors }"
                      >
                        <option selected></option>
                        @for (object of getDropdownDataObjectArray("invoiceDetails_PaymentMethodId"); track object.id) {
                          <option [ngValue]="object.id">{{object.description}}</option>    
                        }
                      </select>
                      <div class="invalid-feedback">A value is required</div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="invoiceDetails_PaymentTermId-field" class="form-label text-right"
                        [class.required]="isRequired('invoiceDetailsForm.invoiceDetails_PaymentTermId')"
                      >
                        Payment Term
                      </label>
                      <select
                        class="form-select"
                        name="invoiceDetails_PaymentTermId-field"
                        id="invoiceDetails_PaymentTermId-field"
                        formControlName="invoiceDetails_PaymentTermId"
                        [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_PaymentTermId'].errors }"
                      >
                        <option selected></option>
                        @for (object of getDropdownDataObjectArray("invoiceDetails_PaymentTermId"); track object.id) {
                          <option [ngValue]="object.id">{{object.description}}</option>    
                        }
                      </select>
                      <div class="invalid-feedback">A value is required</div>
                    </div>
                  </div>
                </div>

                @if (creditLimitsEnabled) {
                  <div class="row mb-3">
                    <div class="col-12">
                      <div class="border border-success rounded">
                        <div class="row">
                          <div class="col-12">
                            <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center" role="alert">
                              <strong>Credit Limit</strong>
                              <div class="form-check form-switch form-switch-md label-left-switch">
                                <label class="form-check-label mb-0" for="invoiceDetails_creditLimitEnabled-field">Enable</label>
                                <input class="form-check-input" type="checkbox" role="switch"
                                       id="invoiceDetails_creditLimitEnabled-field"
                                       formControlName="invoiceDetails_creditLimitEnabled"
                                       (change)="creditLimitEnabledToggle()">
                              </div>
                            </div>
                          </div>
                        </div>

                        @if (creditLimitEditBlocked) {
                          <div class="row px-3 pb-2">
                            <div class="col-12">
                              <div class="text-muted small">
                                You cannot change the credit limit of your own company. Please contact your parent company to action.
                              </div>
                            </div>
                          </div>
                        }

                        @if (creditLimitEnabled) {
                          <div class="row px-3 pb-3">
                            <div class="col-6">
                              <div class="mb-3">
                                <label for="invoiceDetails_creditLimit-field" class="form-label">Credit Limit</label>
                                <div class="input-group">
                                  <span class="input-group-text">£</span>
                                  <input type="number"
                                         class="form-control text-end"
                                         id="invoiceDetails_creditLimit-field"
                                         formControlName="invoiceDetails_creditLimit"
                                         placeholder=""
                                         data-lpignore="true"
                                         [ngClass]="{ 'is-invalid': creditLimitExceedsParent || (companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_creditLimit'].errors) }">
                                </div>
                                @if (companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_creditLimit'].errors) {
                                  <div class="invalid-feedback">A value is required</div>
                                }
                                @if (parentCreditLimitHint) {
                                  <div class="form-text text-muted">{{ parentCreditLimitHint }}</div>
                                }
                                @if (creditLimitExceedsParent) {
                                  <div class="text-danger small mt-1">Value exceeds the parent company credit limit</div>
                                }
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-3">
                                <label for="invoiceDetails_currentCreditLimit-field" class="form-label">Current Credit Limit (this month only)</label>
                                <div class="input-group">
                                  <span class="input-group-text">£</span>
                                  <input type="number"
                                         class="form-control text-end"
                                         id="invoiceDetails_currentCreditLimit-field"
                                         formControlName="invoiceDetails_currentCreditLimit"
                                         placeholder=""
                                         data-lpignore="true"
                                         [ngClass]="{ 'is-invalid': currentCreditLimitExceedsParent }">
                                </div>
                                <div class="form-text text-muted">Leave blank to use the standard credit limit</div>
                                @if (currentCreditLimitExceedsParent) {
                                  <div class="text-danger small mt-1">Value exceeds the parent company credit limit</div>
                                }
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-3">
                                <label for="invoiceDetails_creditLimitExceedAction-field" class="form-label">When limit is exceeded</label>
                                <select class="form-select"
                                        id="invoiceDetails_creditLimitExceedAction-field"
                                        formControlName="invoiceDetails_creditLimitExceedAction"
                                        [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_creditLimitExceedAction'].errors }">
                                  <option [ngValue]="null" value=""></option>
                                  <option [ngValue]="0">Nothing</option>
                                  <option [ngValue]="1">Suspend</option>
                                  <option [ngValue]="2">Throttle 512Kbps</option>
                                </select>
                                @if (companyFormSubmitted && formOfInvoiceDetails['invoiceDetails_creditLimitExceedAction'].errors) {
                                  <div class="invalid-feedback">A value is required</div>
                                }
                              </div>
                            </div>
                            @if (!creditLimitEditBlocked) {
                              <div class="col-12">
                                <div class="text-muted small">
                                  Connections are reinstated automatically within a few minutes of a limit increase.
                                </div>
                              </div>
                            }
                          </div>
                        }
  
                      </div>
                    </div>
                  </div>
                }

                @if (!newCompany) {
                  <div class="row">
                    <div class="col-12 mb-3">
                      <div class="border border-success rounded">
                        <div class="row">
                          <div class="col-12">
                            <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center" role="alert">
                              <strong>Billing Recipients</strong>
                              <div class="form-check form-switch form-switch-md label-left-switch">
                                <label class="form-check-label mb-0" for="invoiceDetails_BillOnly-field">Show billing only</label>
                                <input class="form-check-input" type="checkbox" role="switch" id="invoiceDetails_BillOnly-field"
                                       formControlName="invoiceDetails_BillOnly" (click)="showBillingOnlyClick()">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="px-2">
                          <app-users-all-embedded
                            #usersAllRef
                            [companyId]="this.sureSimCompanyId"
                            [filterExpr]="billingRecipientsFilterExpr"
                            (gridAddClick)="billRecipientsGridAddButtonClick()"
                            (gridEditClick)="billRecipientsGridEditButtonClick($event)"
                          ></app-users-all-embedded>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <div class="row mb-3">
                  <div class="col-12">
                    <div class="border border-success rounded">
                      <div class="row">
                        <div class="col-12">
                          <div class="alert border-0 alert-primary" role="alert">
                            <strong>Billing Format</strong>
                          </div>
                        </div>
                      </div>
                      <!--
                      <div class="row">
                        <div class="col-12 mb-3 ps-4">

                          <div class="form-check form-switch form-switch-md d-inline-block me-4">
                            <label class="form-check-label" for="invoiceDetails_invoice-field">Invoice</label>
                            <input class="form-check-input" type="checkbox" role="switch" id="invoiceDetails_invoice-field" formControlName="invoiceDetails_invoice" (click)="invoiceClick()">
                          </div>

                          <div class="form-check form-switch form-switch-md d-inline-block me-4">
                            <label class="form-check-label" for="invoiceDetails_statement-field">Statement</label>
                            <input class="form-check-input" type="checkbox" role="switch" id="invoiceDetails_statement-field" formControlName="invoiceDetails_statement" (click)="statementClick()">
                          </div>

                        </div>
                      </div>
                      -->
                      <div class="row">
                        <div class="col-12 mb-3 ps-4">

                          <div class="btn-group billing-format-toggle" role="group" aria-label="Billing Format">
                            <!--
                            <input type="radio" class="btn-check" name="invoiceDetails_billFormat" id="noneradio"
                                   formControlName="invoiceDetails_billFormat" [value]="'none'">
                            <label class="btn btn-outline-success mb-0" for="noneradio">None</label>
                            -->
                            <input type="radio" class="btn-check" name="invoiceDetails_billFormat" id="invoiceradio"
                                   formControlName="invoiceDetails_billFormat" [value]="'invoice'">
                            <label class="btn btn-outline-success mb-0" for="invoiceradio">Invoice</label>
                          
                            <input type="radio" class="btn-check" name="invoiceDetails_billFormat" id="statementradio"
                                   formControlName="invoiceDetails_billFormat" [value]="'statement'">
                            <label class="btn btn-outline-success mb-0" for="statementradio">Statement</label>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                @if (showStatementLogo) {
                  <div class="row mb-3">
                    <div class="col-4">
                      <div class="border border-success rounded d-flex flex-column" style="height: 100%;">
                        <div>
                          <div class="alert border-0 alert-primary mb-0" role="alert">
                            <strong>Statement Logo</strong>
                          </div>
                        </div>

                        <div class="flex-grow-1 position-relative" style="min-height: 90px;">
                          @if (statementLogoFileUrl) {
                            <img
                              [src]="statementLogoFileUrl"
                              alt="Statement logo preview"
                              style="width: 100%; height: 100%; object-fit: contain;"
                            >
                          }
                          <input
                            [attr.accept]="statementLogoAcceptTypes"
                            class="form-control form-control-sm w-100 position-absolute bottom-0 start-0"
                            data-lpignore="true"
                            id="invoiceDetails_statementLogoFileData-field"
                            placeholder=""
                            style="opacity: 0;"
                            type="file"
                            (change)="statementLogoFileSelected($event)"
                          />
                        </div>

                        <button
                          type="button"
                          class="btn btn-success w-100 rounded-0 text-white"
                          (click)="triggerStatementLogoFileInput()"
                        >
                          Choose file
                        </button>

                      </div>
                    </div>
                    <div class="col-8 d-flex align-items-end">
                      <small class="text-muted fw-normal">
                        Appears in statement headers. PNG or JPEG only.<br />
                        Sub-companies inherit this logo unless they have their own.
                      </small>
                    </div>
                  </div>
                }

              </div>
            </ng-template>
          </li>
        }
  
        @if (showTariffAndPricing) {
          <li [ngbNavItem]="navItemTariffPricing">
            <a ngbNavLink>
              @if(showCompanyTabIcons) {
                <span class="d-block"><i class="mdi mdi-calculator"></i></span>
              }
              <span class="d-sm-block">{{tabTitleTariffs}}</span>
            </a>
            <ng-template ngbNavContent>
                ...Tariff & Pricing...
            </ng-template>
          </li>
        }
  
        @if (showPortalDetails) {
          <li [ngbNavItem]="navItemPortalDetails">
            <a ngbNavLink>
              @if(showCompanyTabIcons) {
                <span class="d-block"><i class="mdi mdi-monitor"></i></span>
              }
              <span class="d-sm-block">{{tabTitlePortal}}</span>
            </a>
            <ng-template ngbNavContent>
              <div formGroupName="portalDetailsForm">

                <div class="row mb-3">
                  <div class="col-12">
                    <div class="border border-success rounded">
                      <div class="row">
                        <div class="col-12">
                          <div class="alert border-0 alert-primary" role="alert">
                            <strong>Configuration</strong>
                          </div>
                        </div>
                      </div>
                
                      <div class="row">
                        <div class="col-12 mb-3 ps-4">

                          <div class="form-check form-switch form-switch-md d-inline-block me-4">
                            <label class="form-check-label" for="portalDetails_PortalAccess-field">Portal Access</label>
                            <input class="form-check-input" type="checkbox" role="switch" id="portalDetails_PortalAccess-field" formControlName="portalDetails_PortalAccess" (click)="portalAccessClick()">
                          </div>

                          <div class="form-check form-switch form-switch-md d-inline-block me-4">
                            <label class="form-check-label" for="portalDetails_Branding-field">Branded Portal</label>
                            <input class="form-check-input" type="checkbox" role="switch" id="portalDetails_Branding-field" formControlName="portalDetails_Branding" (click)="brandedPortalClick()">
                          </div>

                          <div class="form-check form-switch form-switch-md d-inline-block">
                            <label class="form-check-label" for="portalDetails_CreateSubCompanies-field">Create Sub-Companies</label>
                            <input class="form-check-input" type="checkbox" role="switch" id="portalDetails_CreateSubCompanies-field" formControlName="portalDetails_CreateSubCompanies">
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                @if (formOfPortalDetails['portalDetails_Branding'] && formOfPortalDetails['portalDetails_Branding'].value) {
                  <div class="row mb-3">
                    <div [ngClass]="{ 'is-invalid': companyFormSubmitted && !haveLogoToUpload && !haveLogoFromDatabase }">
                      <div class="col-4">
                        <div class="border border-success rounded d-flex flex-column" style="height: 100%;">
                          <div>
                            <div class="alert border-0 alert-primary mb-0" role="alert">
                              <strong>Company Logo</strong>
                            </div>
                          </div>
                                   
                          <div class="flex-grow-1 position-relative">
                            <img
                              *ngIf="logoFileUrl"
                              [src]="logoFileUrl"
                              alt="Preview"
                              style="width: 100%; height: 100%; object-fit: cover;"
                            >
                            <input
                              accept="image/*"
                              class="form-control form-control-sm w-100 position-absolute bottom-0 start-0"
                              data-lpignore="true"
                              id="portalDetails_logoFileData-field"
                              placeholder=""
                              style="opacity: 0;"
                              type="file"
                              (change)="logoFileSelected($event)"
                            />
                          </div>
                                   
                          <button
                            type="button"
                            class="btn btn-success w-100 rounded-0 text-white"
                            (click)="triggerLogoFileInput()"
                          >
                            Choose file
                          </button>
                                   
                        </div>
                      </div>
                    </div>
                    <div class="invalid-feedback">Required for a Branded Portal</div>
                  </div>
                }

                @if (!newCompany) {
                  <div class="row">
                    <div class="col-12 mb-3">
                      <div class="border border-success rounded">
                        <div class="row">
                          <div class="col-12">
                            <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center" role="alert">
                              <strong>Portal Users</strong>
                            </div>
                          </div>
                        </div>
                        <div class="px-2">
                          <app-users-portal-embedded
                            #usersPortalRef
                            [companyId]="this.sureSimCompanyId"
                            (gridAddClick)="portalUsersGridAddButtonClick()"
                            (gridEditClick)="portalUsersGridEditButtonClick($event)"
                          ></app-users-portal-embedded>
                        </div>
                      </div>
                    </div>
                  </div>
                }

              </div>
            </ng-template>
          </li>
        }
        
        @if (showLicenceDetails) {
          <li [ngbNavItem]="navItemLicenceDetails">
            <a ngbNavLink>
              @if(showCompanyTabIcons) {
                <span class="d-block"><i class="mdi mdi-card-account-details-outline"></i></span>
              }
              <span class="d-sm-block">{{tabTitleLicencing}}</span>
            </a>
            <ng-template ngbNavContent>
              <div formGroupName="licenceDetailsForm">

                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="border border-success rounded">
                      <div class="row">
                        <div class="col-12">
                          <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center" role="alert">
                            <strong>{{licencesGridTitle}}</strong>
                            @if (curUserIsUtelize && (!newCompany || enableLicenceDetailsOnNew)) {
                              <div class="form-check form-switch form-switch-md label-left-switch">
                                <label class="form-check-label mb-0" for="licenceDetailsForm_visible-field">Show Allowed</label>
                                <input class="form-check-input" type="checkbox" role="switch" id="licenceDetailsForm_visible-field"
                                       formControlName="licenceDetailsForm_visible" (click)="showCompanyVisibleLicencesClick()">
                              </div>
                            }
                          </div>
                        </div>
                      </div>

                      <div class="px-2">
                        <div class="row">
                          @if (licencesAllowedShowing) {
                              <app-licences-company-visible-embedded
                                [companyId]="this.sureSimCompanyId"
                              ></app-licences-company-visible-embedded>
                          } @else {
                              <app-licences-company-allocated-cards #licenceCards
                                [companyId]="sureSimCompany?.id"
                                [newCompany]="newCompany"
                              ></app-licences-company-allocated-cards>
                          }
                        </div>
                      </div>
                      
                      @if (!licencesAllowedShowing) {
                        <div class="card-body px-0 pb-0">
                          <div role="alert"
                               class="alert alert-light border border-success rounded mb-0 d-flex justify-content-end"
                               style="position:relative;
                                      left:-1px;
                                      width:calc(100% + 2px);
                                      bottom:-1px;
                                      border-radius:0;"
                          >
                            <button type="button" class="btn btn-success" (click)="searchForVisibleLicences()">Add Licence</button>
                          </div>
                        </div>
                      }

                    </div>
                  </div>
                </div>

              </div>
            </ng-template>
          </li>
        }
        
        @if (showSpendLimits) {
          <li [ngbNavItem]="navItemUsageLimits">
            <a ngbNavLink>
              @if(showCompanyTabIcons) {
                <span class="d-block"><i class="mdi mdi-finance"></i></span>
              }
              <span class="d-sm-block">{{tabTitleSpendLimits}}</span>
            </a>
            <ng-template ngbNavContent>
              <div formGroupName="usageLimitsForm">

                <div class="limit-info-box mb-3">
                  <i class="bi-info-circle-fill me-2"></i>
                  Set <strong class="text-success">default company limits</strong> that will be applied to all SIMs unless a custom limit is configured for individual SIMs.
                </div>

                <div class="border border-success rounded p-3">
                  <p class="fw-semibold mb-3">Default Company Limits</p>

                  <!-- Limit Type Cards -->
                  <div class="row g-3 mb-3 justify-content-center">
                    @if (showCompanyNoLimit) {
                      <div class="col-4">
                        <div class="limit-type-card" [class.selected]="selectedLimitType === LimitType.Off" (click)="selectLimitType(LimitType.Off)">
                          <span class="limit-card-icon"><i class="bi-infinity"></i></span>
                          <div class="limit-card-title">No Limit</div>
                          <div class="limit-card-subtitle">No restrictions on usage</div>
                        </div>
                      </div>
                    }
                    <div class="col-4">
                      <div class="limit-type-card" [class.selected]="selectedLimitType === LimitType.Spend" (click)="selectLimitType(LimitType.Spend)">
                        <span class="limit-card-icon" [class.text-success]="selectedLimitType === LimitType.Spend"><i class="bi-cash-stack"></i></span>
                        <div class="limit-card-title" [class.text-success]="selectedLimitType === LimitType.Spend">Spend Limit</div>
                        <div class="limit-card-subtitle">Restrict by cost threshold</div>
                      </div>
                    </div>
                    @if (showCompanyDataLimit) {
                      <div class="col-4">
                        <div class="limit-type-card" [class.selected]="selectedLimitType === LimitType.Data" (click)="selectLimitType(LimitType.Data)">
                          <span class="limit-card-icon" [class.text-success]="selectedLimitType === LimitType.Data"><i class="bi-bar-chart-fill"></i></span>
                          <div class="limit-card-title" [class.text-success]="selectedLimitType === LimitType.Data">Data Usage Limit</div>
                          <div class="limit-card-subtitle">Restrict by data volume</div>
                        </div>
                      </div>
                    }
                  </div>

                  @if (selectedLimitType === LimitType.Spend) {
                    <div class="mb-3">
                      <label for="usageLimits_limit-field" class="form-label fw-semibold"
                        [class.required]="isRequired('usageLimitsForm.usageLimits_limit')"
                      >
                        Default Spend Limit
                      </label>
                      <div class="input-group has-validation">
                        @if (companyCurrencySymbol) {
                          <span class="input-group-text">{{ companyCurrencySymbol }}</span>
                        }
                        <input
                          [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                          [attr.name]="autofill ? 'usageLimits_limit-field' : 'usageLimits_limit-field-secret'"
                          class="form-control"
                          formControlName="usageLimits_limit"
                          id="usageLimits_limit-field"
                          [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfUsageLimits['usageLimits_limit'].errors }"
                          placeholder=""
                          type="number"
                        />
                        <div class="invalid-feedback">A value is required</div>
                      </div>
                      <div class="form-text text-muted">Maximum spend per SIM</div>
                    </div>
                  }

                  @if (selectedLimitType === LimitType.Data) {
                    <div class="mb-1">
                      <label for="usageLimits_dataLimit-field" class="form-label fw-semibold"
                        [class.required]="isRequired('usageLimitsForm.usageLimits_dataLimit')"
                      >
                        Default Data Limit
                      </label>
                      <div class="d-flex align-items-stretch gap-2">
                        <input
                          [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                          [attr.name]="autofill ? 'usageLimits_dataLimit-field' : 'usageLimits_dataLimit-field-secret'"
                          class="form-control flex-grow-1"
                          formControlName="usageLimits_dataLimit"
                          id="usageLimits_dataLimit-field"
                          [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfUsageLimits['usageLimits_dataLimit'].errors }"
                          placeholder=""
                          type="number"
                        />
                        <div class="segmented-toggle" role="group" aria-label="Data limit unit">
                          <input
                            class="segmented-toggle-input"
                            formControlName="usageLimits_dataLimitUnit"
                            id="usageLimits_dataLimitUnit-mb"
                            type="radio"
                            value="MB"
                          />
                          <label class="segmented-toggle-option" for="usageLimits_dataLimitUnit-mb">MB</label>

                          <input
                            class="segmented-toggle-input"
                            formControlName="usageLimits_dataLimitUnit"
                            id="usageLimits_dataLimitUnit-gb"
                            type="radio"
                            value="GB"
                          />
                          <label class="segmented-toggle-option" for="usageLimits_dataLimitUnit-gb">GB</label>
                        </div>
                      </div>
                      <div class="form-text text-muted">Maximum data per SIM</div>
                      <div class="invalid-feedback">A value is required</div>
                    </div>
                  }

                </div>
              </div>
            </ng-template>
          </li>
        }
        
        @if (showSingleSignOn && featureEnabledSso) {
          <li [ngbNavItem]="navItemSingleSignOn">
            <a ngbNavLink>
              @if(showCompanyTabIcons) {
                <span class="d-block"><i class="mdi mdi-account-lock-outline"></i></span>
              }
              <span class="d-sm-block">{{tabTitleSingleSignOn}}</span>
            </a>
            <ng-template ngbNavContent>
              <div formGroupName="ssoForm">
                <div class="row">
                  <div class="col-12">
                    <div class="border border-success rounded">
                      <div class="row">
                        <div class="col-12">
                          <div class="alert border-0 alert-primary w-100" role="alert">
                            <div class="d-flex align-items-center justify-content-between w-100">
                              <strong>Microsoft</strong>
                              <div class="d-flex align-items-center text-muted">
                                <label for="ssoForm_ssoMicrosoft-field"
                                       class="mb-0"
                                       style="white-space: nowrap; margin-right: 1rem;">
                                  Enable SSO
                                </label>
                                <input class="form-check-input form-switch form-switch-md"
                                       type="checkbox"
                                       role="switch"
                                       id="ssoForm_ssoMicrosoft-field"
                                       formControlName="ssoForm_ssoMicrosoft"
                                       (click)="ssoMicrosoftClick()">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      @if (ssoControlsShowMicrosoft) {
                        <div class="col-12">
                          <div class="row">
                            <div class="col-12">
                              <div class="mb-3 px-2">
                                <label for="ssoForm_ssoMicrosoftTenantId-field" class="form-label"
                                  [class.required]="isRequired('ssoForm.ssoForm_ssoMicrosoftTenantId')"
                                >
                                  Tenant ID
                                </label>
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'ssoForm_ssoMicrosoftTenantId-field' : 'ssoForm_ssoMicrosoftTenantId-field-secret'"
                                  class="form-control"
                                  data-lpignore="true"
                                  formControlName="ssoForm_ssoMicrosoftTenantId"
                                  id="ssoForm_ssoMicrosoftTenantId-field"
                                  [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfSso['ssoForm_ssoMicrosoftTenantId'].errors }"
                                  [placeholder]="requireSsoTenantIdMicrosoft ? '' : 'Optional'"
                                  type="text"
                                />
                                @if(formOfSso['ssoForm_ssoMicrosoftTenantId'].hasError('invalidGuid')) {
                                 <div class="invalid-feedback">The Tenant ID must be a valid GUID</div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      }
  
                     </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
        
        @if (showDeviceManagement && featureEnabledMdm) {
          <li [ngbNavItem]="navItemDeviceManagement">
            <a ngbNavLink>
              @if(showCompanyTabIcons) {
                <span class="d-block"><i class="mdi mdi-devices"></i></span>
              }
              <span class="d-sm-block">{{tabTitleDeviceManagement}}</span>
            </a>
            <ng-template ngbNavContent>
              <div formGroupName="mdmForm">
                <div class="row">
                  <div class="col-12">
                    <div class="border border-success rounded">
                      <div class="row">
                        <div class="col-12">
                          <div class="alert border-0 alert-primary w-100" role="alert">
                            <div class="d-flex align-items-center justify-content-between w-100">
                              <strong>Microsoft Intune</strong>
                              <div class="d-flex align-items-center text-muted">
                                @if (showMdmDesensitise) {
                                  <label
                                    class="mb-0"
                                    for="mdmForm_mdmDesensitise-field"
                                    style="white-space: nowrap; margin-right: 1rem;"
                                  >
                                    Desensitise
                                  </label>
                                  <input
                                    class="form-check-input form-switch form-switch-md"
                                    formControlName="mdmForm_mdmDesensitise"
                                    id="mdmForm_mdmDesensitise-field"
                                    role="switch"
                                    style="margin-right: 2rem;"
                                    type="checkbox"
                                  >
                                }
                                <label for="mdmForm_mdmMicrosoft-field"
                                       class="mb-0"
                                       style="white-space: nowrap; margin-right: 1rem;">
                                  Enable MDM
                                </label>
                                <input class="form-check-input form-switch form-switch-md"
                                       type="checkbox"
                                       role="switch"
                                       id="mdmForm_mdmMicrosoft-field"
                                       formControlName="mdmForm_mdmMicrosoft"
                                       (click)="mdmMicrosoftClick()">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      @if (mdmControlsShowMicrosoft) {
                        <div class="col-12">
                          <div class="row">
                            <div class="col-12">
                              <div class="mb-3 px-2">
                                <label for="mdmForm_mdmMicrosoftTenantId-field" class="form-label"
                                  [class.required]="isRequired('mdmForm.mdmForm_mdmMicrosoftTenantId')"
                                >
                                  Tenant ID
                                </label>
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'mdmForm_mdmMicrosoftTenantId-field' : 'mdmForm_mdmMicrosoftTenantId-field-secret'"
                                  class="form-control"
                                  data-lpignore="true"
                                  formControlName="mdmForm_mdmMicrosoftTenantId"
                                  id="mdmForm_mdmMicrosoftTenantId-field"
                                  [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfMdm['mdmForm_mdmMicrosoftTenantId'].errors }"
                                  placeholder=""
                                  type="text"
                                />
                                @if(formOfMdm['mdmForm_mdmMicrosoftTenantId'].hasError('invalidGuid')) {
                                 <div class="invalid-feedback">The Tenant ID must be a valid GUID</div>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <div class="mb-3 px-2">
                                <label for="mdmForm_mdmMicrosoftClientId-field" class="form-label"
                                  [class.required]="isRequired('mdmForm.mdmForm_mdmMicrosoftClientId')"
                                >
                                  Client ID
                                </label>
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'mdmForm_mdmMicrosoftClientId-field' : 'mdmForm_mdmMicrosoftClientId-field-secret'"
                                  class="form-control"
                                  data-lpignore="true"
                                  formControlName="mdmForm_mdmMicrosoftClientId"
                                  id="mdmForm_mdmMicrosoftClientId-field"
                                  [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfMdm['mdmForm_mdmMicrosoftClientId'].errors }"
                                  placeholder=""
                                  type="text"
                                />
                                @if(formOfMdm['mdmForm_mdmMicrosoftClientId'].hasError('invalidGuid')) {
                                 <div class="invalid-feedback">The Client ID must be a valid GUID</div>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <div class="mb-3 px-2">
                                <label for="mdmForm_mdmMicrosoftClientSecret-field" class="form-label"
                                  [class.required]="isRequired('mdmForm.mdmForm_mdmMicrosoftClientSecret')"
                                >
                                  Client Secret
                                </label>
                                <input
                                  [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                                  [attr.name]="autofill ? 'mdmForm_mdmMicrosoftClientSecret-field' : 'mdmForm_mdmMicrosoftClientSecret-field-secret'"
                                  class="form-control"
                                  data-lpignore="true"
                                  formControlName="mdmForm_mdmMicrosoftClientSecret"
                                  id="mdmForm_mdmMicrosoftClientSecret-field"
                                  [ngClass]="{ 'is-invalid': companyFormSubmitted && formOfMdm['mdmForm_mdmMicrosoftClientSecret'].errors }"
                                  placeholder=""
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row mb-2 px-2">
                            <div class="col-12">
                              <div class="d-flex align-items-center">
                                <ng-container *ngIf="!canTestIntuneConnection()">
                                  <span class="fs-4 me-1">⚠️</span>
                                  <span class="form-text mb-0">Submit credentials before testing</span>
                                </ng-container>
                                <ng-container *ngIf="canTestIntuneConnection() && mdmTestConnectionResult !== undefined">
                                  <span class="fs-4 me-1">
                                    {{ mdmTestConnectionResult ? '👍' : '⚠️' }}
                                  </span>
                                    <span class="form-text mb-0">
                                      A connection could
                                      <ng-container *ngIf="!mdmTestConnectionResult">not </ng-container>
                                      be established
                                    </span>
                                </ng-container>
                                <button
                                  class="btn btn-success ms-auto"
                                  [disabled]="!canTestIntuneConnection()"
                                  type="button"
                                  (click)="testIntuneConnection()"
                                >
                                  Test Connection
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
  
                     </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }

        @if (showAlerts) {
          <li [ngbNavItem]="navItemCompanyAlerts">
            <a ngbNavLink>
              <span class="d-block"><i class="ri-alert-line"></i></span>
              <span class="d-sm-block">{{tabTitleAlerts}}</span>
            </a>
            <ng-template ngbNavContent>
              <div>
                <div class="row" style="height:471px;">
                  <div class="col-12">
                    <app-alerts-modal-form #alertsForm
                      [companyId]="sureSimCompany?.id"
                      [featureEnabledCountryPlans]="featureEnabledCountryPlans"
                      [featureEnabledLocationWebhook]="featureEnabledLocationWebhook"
                      [isCompany]="true"
                      [newCompany]="newCompany"
                      (alertDataHasBeenSaved)="companyAlertSaved()"
                      (alertGroupChanged)="alertGroupChanged($event)"
                    ></app-alerts-modal-form>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }

        @if (showSupport) {
          <li [ngbNavItem]="navItemSupport">
            <a ngbNavLink>
              <span class="d-block"><i class="bi-ticket-perforated"></i></span>
              <span class="d-sm-block">{{tabTitleSupport}}</span>
            </a>
            <ng-template ngbNavContent>
              <div>
                <div class="row">
                  <div class="col-12">
                    <app-manage-tickets
                         [companyId]="sureSimCompany?.id"
                         [initialInviewCompanyId]="sureSimCompany?.id"
                         [newCompany]="newCompany"
                         [initialSureSimDeviceId]="-1"
                         [initialSureSimUserId]="-1"
                         [isCompany]="true"
                         [isDevice]="false"
                         [isUser]="false"
                         [matchCompanyAndUser]="false"
                    ></app-manage-tickets>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
        @if (showLocationServices) {
          <li [ngbNavItem]="navItemLocationServices">
            <a ngbNavLink>
              <span class="d-block"><i class="ri-map-pin-2-line"></i></span>
              <span class="d-sm-block">Location</span>
            </a>
            <ng-template ngbNavContent>
              <div>
                <div class="row">
                  <div class="col-12">
                    @if(iccidClicked.observed) {
                    <app-map-sim-locations #mapSimLocations
                      [companyId]="sureSimCompanyId"
                      [wideSidebar]="true"
                      (editLocationConsentTemplate)="onEditLocationConsentTemplate()"
                      (locationSettingsChanged)="onCompanyLocationSettingsChanged()"
                    ></app-map-sim-locations>
                    } @else {
                    <app-map-sim-locations #mapSimLocations
                      [companyId]="sureSimCompanyId"
                      [wideSidebar]="true"
                      (editLocationConsentTemplate)="onEditLocationConsentTemplate()"
                      (locationSettingsChanged)="onCompanyLocationSettingsChanged()"
                    ></app-map-sim-locations>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
        
      </ul>
      
      <div class="tab-content">
        <div [ngbNavOutlet]="ArrowNgbNav"></div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            @if(this.activeId == navItemCompanyAlerts) {
            <div class="hstack justify-content-start">
              <app-dropdown-alert-default-template #alertdefaulttemplate
              [showLabel]="true"
              [alertGroupId]="alertGroupId"
              (selectOnChangeEvent)="companyFormAlertTemplate($event)"
              >
              </app-dropdown-alert-default-template>
              <button type="button" class="btn btn-success" (click)="companyFormAlert()">Add</button>
            </div>
            } @else {
            <div class="hstack gap-2 justify-content-start">
              @if (canCeaseCompany) {
                <span tooltipClass="custom-tooltip-danger" container="body" [ngbTooltip]="ceaseBlockedBySims ? ceaseBlockedHint : null">
                  <button type="button" class="btn btn-danger" [disabled]="ceaseInProgress || ceaseBlockedBySims" (click)="ceaseCompanyClick()">Cease Company</button>
                </span>
              }
              <!-- CRN_20261021 - Retired
              @if (canUnceaseCompany) {
                <button type="button" class="btn btn-success" [disabled]="ceaseInProgress" (click)="unceaseCompanyClick()">Reinstate Company</button>
              }
              -->
              @if (canRepeatCease) {
                <span tooltipClass="custom-tooltip-danger" container="body" [ngbTooltip]="ceaseBlockedBySims ? ceaseBlockedHint : 'Some user details could not be removed from Inview. Repeat the cease to complete the removal.'">
                  <button type="button" class="btn btn-danger" [disabled]="ceaseInProgress || ceaseBlockedBySims" (click)="ceaseCompanyClick()">Repeat Cease</button>
                </span>
              }
            </div>
            }
          </div>
          <div class="col-6">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="companyFormCancel()">Close</button>
              <button type="submit" [disabled]="!submitButtonEnabled || formIsLocked" class="btn btn-success" id="add-btn">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<app-address-modal-form #addressModalForm
  [defaultCountryId]="selectCountryId"
  (addressFormCancelled)="addressFormHasBeenCancelled()"
  (dataHasBeenSaved)="addressDataHasBeenSaved($event)"
></app-address-modal-form>

<app-alert-modal-edit-form #alertModalForm
  [initialCompanyId]="sureSimCompany?.id"
  (alertDataHasBeenSaved)="companyFormAlertAdded()"
></app-alert-modal-edit-form>

<app-communication-modal-form #communicationModalForm
  [initialSureSimCompanyId]="sureSimCompany?.id"
  (formCancelled)="communicationFormHasBeenCancelled()"
  (dataHasBeenSaved)="communicationDataHasBeenSaved($event)"
></app-communication-modal-form>

@if (showComposeForm) {
  <app-communication-compose-modal-form #communicationComposeModalForm
    (formCancelled)="communicationFormHasBeenCancelled()"
    (dataHasBeenSaved)="communicationDataHasBeenSaved($event)"
  ></app-communication-compose-modal-form>
}

<app-completed-modal-form #ceaseCompletedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-confirmation-modal-form #ceaseCompanyConfirmModal
  (modalYes)="yesCeaseCompany($event)"
></app-confirmation-modal-form>

<!-- CRN_20261021 - Retired
<app-confirmation-modal-form #unceaseCompanyConfirmModal
  (modalYes)="yesUnceaseCompany()"
></app-confirmation-modal-form>
-->

<app-information-modal-form #informationModalForm
></app-information-modal-form>

<app-licences-company-visible-modal-form-search #visibleLicencesSearchForm
  [allocateSelectedLicence]="true"
  (searchFormCancelled)="visibleLicencesSearchFormCancelled()"
  (searchFormHasBeenSaved)="visibleLicencesSearchFormHasBeenSaved()"
></app-licences-company-visible-modal-form-search>

<!--RBW_20260925 - Location Consent Request is an SMS only message type, so only the SMS template is offered here.-->
<app-template-sms-modal-form #locationConsentTemplateForm
  [bodyOnly]="true"
  title="Location Consent Message"
  updateMessage="Message Updated."
></app-template-sms-modal-form>

<app-user-modal-form #userModalForm
  [disableCompanyModal]="true"
  [initialInviewCompanyId]="sureSimCompany?.inviewCompanyID"
  [lockCompanyDropDown]="true"
  (sureSimUserDataHasBeenSaved)="userModalFormDataHasBeenSaved($event)"
  (userFormCancelled)="userModalFormHasBeenCancelled()"
></app-user-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
